import { createDraftStorage, type DuplicateFormDraft } from './duplicateFormDraft'

export type { DuplicateFormDraft as NewBriefDraft }

const { save, load, clear } = createDraftStorage<DuplicateFormDraft>('hb_new_brief_draft')

export const saveNewBriefDraft = save
export const loadNewBriefDraft = load
export const clearNewBriefDraft = clear
